export const comminucationRfe = {
	title: "Réforme de la Facturation Électronique",
	action: {
		label: "je confirme mon choix",
		title: "Vous confirmez votre choix"
	},
	'no-choice': "je choisis plus tard",
	message: {
		success: "Votre choix concernant la Plateforme Agréée a bien été enregistré.",
		failed: "Impossible d'enregistrer votre choix pour le moment. Veuillez réessayer ultérieurement."
	}
}
